import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import LoginPage from './features/auth/LoginPage';
import PlayersPage from './features/Players/PlayersPage';
import ClientsPage from './features/Clients/ClientsPage';
import { useAppSelector } from './app/hooks';
import SideBar from './components/SideBar/SideBar';
import { Box, Toolbar } from '@mui/material';
import UsersPage from "./features/Users/UsersPage";
import AdvertisersPage from "./features/Advertisers/AdvertisersPage";

const RequireAuth: React.FC = () => {
    const token = localStorage.getItem("sdc-token");
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

const Layout: React.FC = () => {
  return (
      <Box sx={{ display: 'flex' }}>
        <SideBar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Outlet />
        </Box>
      </Box>
  );
};

const App: React.FC = () => {
  return (
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route element={<Layout />}>
              <Route path="/Players" element={<PlayersPage />} />
              <Route path="/Clients" element={<ClientsPage />} />
              <Route path="/Advertisers" element={<AdvertisersPage/>} />
                <Route path="/Users" element={<UsersPage />} />
              <Route path="/" element={<Navigate to="/Players" replace />} />
            </Route>
          </Route>
        </Routes>
      </Router>
  );
};

export default App;
